import {Injectable} from '@angular/core';
import {Http, Response}  from '@angular/http';
import {AuthHttp, AuthConfig} from 'angular2-jwt';
import {Observable}  from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import {StoreService}  from '../store/store.service';
import {CognitoAuthService} from '../auth/cognito.service';

@Injectable()
export class ThreatService {

    threats: any[ ] = [];
    threatsParams: any = {};
    maxThreatDataCallRetries = 3;
    threatsDataSubscription;

    idToken: string;
    customer: string;
    // timePeriods = ['h', 'd', 'm', 'q', 'y'];

    threatTypes = ['System Compromise', 'Exploitation & Installation', 'Delivery & Attack', 'Reconnaissance & Probing', 'Organizational Insight'];

    timePeriods = {
        'h': ['9:00am', '9:10am', '9:20am', '9:30am', '9:40am', '9:50am'],
        'd': ['12am-4am', '4am-8am', '8am-12pm', '12pm-4pm', '4pm-8pm', '8pm-12am'],
        'w': ['10/02/2016', '10/03/2016', '10/04/2016', '10/05/2016', '10/06/2016', '10/07/2016', '10/08/2016'],
        'm': ['10/02/2016'],
        'q': ['Jul', 'Aug', 'Sep'],
        'y': ['Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
    };

    /*
     threats: any = {
     'w': {
     x: ['10/02/2016', '10/03/2016', '10/04/2016', '10/05/2016', '10/06/2016', '10/07/2016', '10/08/2016'],
     y: [ 'System Compromise', 'Exploitation and Installation', 'Delivery and Attack', 'Recon and Probing', 'Organizational Insight'],
     data: [
     [
     [ [0, 0], [0, 0], [0, 0], [1, 4], [2, 6], [0, 0]],
     [ [0, 0], [1, 2], [0, 0], [0, 0], [0, 0], [0, 0]],
     [ [0, 2], [0, 0], [0, 0], [0, 0], [2, 2], [0, 0]],
     [ [0, 0], [0, 0], [1, 0], [0, 0], [0, 0], [0, 4]],
     [ [0, 0], [0, 0], [0, 4], [0, 0], [0, 0], [0, 0]],
     [ [2, 6], [2, 8], [0, 2], [0, 0], [0, 0], [0, 0]],
     [ [2, 6], [2, 8], [0, 2], [0, 0], [0, 0], [0, 0]]
     ],
     [
     [ [0, 0], [2, 4], [0, 0], [0, 0], [0, 0], [0, 0]],
     [ [0, 0], [0, 0], [0, 0], [0, 0], [1, 2], [0, 0]],
     [ [0, 0], [1, 2], [1, 8], [1, 4], [0, 0], [0, 0]],
     [ [2, 2], [2, 0], [0, 0], [0, 0], [0, 4], [0, 0]],
     [ [0, 0], [0, 0], [0, 0], [1, 8], [2, 0], [0, 0]],
     [ [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
     [ [0, 0], [0, 0], [1, 2], [0, 0], [0, 0], [0, 0]]
     ],
     [
     [ [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
     [ [2, 2], [2, 2], [0, 0], [0, 0], [0, 0], [0, 0]],
     [ [0, 0], [0, 0], [1, 0], [0, 0], [1, 10], [0, 0]],
     [ [0, 2], [1, 2], [0, 0], [0, 0], [0, 0], [0, 0]],
     [ [2, 4], [0, 0], [0, 0], [0, 0], [1, 2], [0, 0]],
     [ [0, 0], [0, 0], [1, 2], [0, 0], [0, 0], [0, 0]],
     [ [0, 0], [0, 0], [1, 6], [0, 0], [0, 0], [0, 0]]
     ],
     [
     [ [0, 0], [2, 4], [0, 0], [0, 0], [0, 0], [0, 0]],
     [ [0, 0], [0, 0], [0, 0], [0, 0], [1, 2], [0, 0]],
     [ [0, 0], [1, 2], [1, 8], [1, 4], [0, 0], [0, 0]],
     [ [2, 2], [2, 0], [0, 0], [0, 0], [0, 4], [0, 0]],
     [ [0, 0], [0, 0], [0, 0], [1, 8], [2, 0], [0, 0]],
     [ [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
     [ [0, 0], [0, 0], [1, 2], [0, 0], [0, 0], [0, 0]]
     ],
     [
     [ [0, 0], [0, 0], [0, 0], [0, 0], [0, 0], [0, 0]],
     [ [2, 2], [2, 2], [0, 0], [0, 0], [0, 0], [0, 0]],
     [ [0, 0], [0, 0], [1, 0], [0, 0], [1, 10], [0, 0]],
     [ [0, 2], [1, 2], [0, 0], [0, 0], [0, 0], [0, 0]],
     [ [2, 4], [0, 0], [0, 0], [0, 0], [1, 2], [0, 0]],
     [ [0, 0], [0, 0], [1, 2], [0, 0], [0, 0], [0, 0]],
     [ [0, 0], [0, 0], [1, 6], [0, 0], [0, 0], [0, 0]]
     ]
     ]
     }
     };
     */

    private static extractData(res: Response) {
        let body = res.json();
        return body || [];
    }

    // TODO: Need to handle different types of errors properly...
    private static handleError(error: any) {
        // In a real world app, we might use a remote logging infrastructure
        // We'd also dig deeper into the error to get a better message
        let errMsg = (error.message) ? error.message :
            error.status ? `${error.status} - ${error.statusText}` : 'Server error';
        console.error(errMsg); // log to console instead
        return Observable.throw(errMsg);
    }

    constructor(public http: Http,
                public authHttp: AuthHttp,
                private store: StoreService,
                private cognitoAuthService: CognitoAuthService) {

        const columns = 7;
        const divisions = 6;
        const self = this;

        // Create mock data for threats
        Object.keys(self.timePeriods).forEach(function (t) {

            self.threats[t] = {x: self.timePeriods[t], y: self.threatTypes.slice(0), data: []};

            for (let i = 0; i < columns; i++) {
                self.threats[t].data[i] = [];
                for (let j = 0; j < columns; j++) {
                    self.threats[t].data[i][j] = [];
                    for (let k = 0; k < divisions; k++) {
                        let r = self.randomInt(0, 9);
                        if (r < 7) {
                            self.threats[t].data[i][j][k] = [self.randomInt(0, 2), 0];
                        } else {
                            self.threats[t].data[i][j][k] = [self.randomInt(0, 2), self.randomInt(0, 5) * 2];
                        }

                    }
                }
            }


        });

    }

    private randomInt(min, max) {
        const self = this;
        return Math.floor(min + (Math.random() * (max - min)));
    }

    getMockThreats() {
        return Object.assign({}, this.threats);
    }

    getThreatsOldWay(idToken: string, customer: string): Observable<any> {

        // XXX: Bad token - that's bad! Elevate risk???
        if (!idToken) {
            console.log('Bad ID Token');
            return Observable.create(function (observer) {
                observer.next([{'risk': 2}]);
                observer.complete();
            });
        }

        const json_token = {token: idToken, customer: customer};

        const apiConfig = this.store.get('apiConfig');

        return this.http.post(apiConfig.threatsURL, json_token, {headers: apiConfig.headers})
            .map(res => res.json())
            .catch(ThreatService.handleError);

    }

    getThreats(params, forceFetchThreatsFromAPI = false): Observable<any> {

        const self = this;

        return Observable.create(function (subscriber) {

            let doFetchThreatsFromAPI = false;

            if ((!self.store.isFresh()) || forceFetchThreatsFromAPI) {

                // console.log('Store is NOT FRESH!');
                doFetchThreatsFromAPI = true;
            } else {

                const storeThreats = self.store.get('threats');

                console.log('storeThreats.length !== 0', (storeThreats.length !== 0));

                const storeThreatsParams = self.store.get('threatsParams');

                let index = -1;
                const paramsPresent = storeThreatsParams.some(function (p) {
                    ++index;
                    return JSON.stringify(p) === JSON.stringify(params);
                });

                // console.log('paramsPresent = ', paramsPresent);
                // console.log('index = ', index);


                if ((storeThreats.length !== 0) && (paramsPresent)) {

                    const threats = storeThreats[index];

                    // console.log('threats at index = ' + index, threats);

                    if (threats == null) {

                        // console.log('threats are NULL at index = ' + index, threats);

                        doFetchThreatsFromAPI = true;
                    } else {

                        // console.log('Retrieving threats from STORE');
                        // console.log('storeThreats = ', storeThreats);
                        // console.log('storeThreatsParams = ', storeThreatsParams);
                        // console.log('================');

                        subscriber.next(threats);
                    }
                } else {
                    doFetchThreatsFromAPI = true;
                }

            }

            // Fetch threats from the API only if the threats in the store on client are not fresh
            // i.e. if they are older than the life of the store
            if (doFetchThreatsFromAPI) {

                // console.log('ThreatService getting threats from API because store is NOT FRESH');

                self.cognitoAuthService.getIdTokenPromise().then(function (idToken) {

                    self.idToken = idToken;
                    self.customer = self.cognitoAuthService.decodeToken(idToken)['custom:customer'];

                    self.threatsDataSubscription = self.callThreatsApi(params).subscribe(function (threats) {

                        // TODO: Ajit - This is copied from AlertService - so you need to check if this is valid for threats too
                        // Adjust the Date field a bit in the Threats list
                        /*
                         self.allEventIds = '';
                         threats.forEach(function (threat) {

                         threat.date = threat.date.substring(0, 19).replace('T', ' ');
                         threat.event_count = (threat.event_ids) ? 1 + (threat.event_ids.match(/,/g) || []).length : 0;
                         // self.allEventIds += threat.event_ids ? (self.allEventIds ? ',' : '') + threat.event_ids : '';

                         });
                         */

                        // self.threats = threats;
                        self.store.update('threatsParams', params);
                        self.store.update('threats', threats);
                        self.store.refresh();

                        // console.log('Got fresh threats from API');
                        // console.log('threats', self.store.get('threats'));
                        // console.log('threatsParams', self.store.get('threatsParams'));
                        // console.log('================');

                        subscriber.next(threats);

                    }, function (err) {

                        self.threats = [];

                        // Retry fetching threats until max number of retries is reached
                        self.threatsDataSubscription.unsubscribe();
                        --self.maxThreatDataCallRetries;
                        if (self.maxThreatDataCallRetries > 0) {
                            self.getThreats(params, true);
                        }
                    });


                }).catch(function (err) {

                    // console.log('Error in getIdTokenPromise()');
                    // console.log(err);

                });

            }
        });

    }

    private callThreatsApi(params): Observable<any> {

        // console.log('this.idToken = ', this.idToken);
        // console.log('this.customer = ', this.customer);

        // const json_token = {token: this.idToken, customer: this.customer};
        const json_token = {range: params.timePeriod};

        const apiConfig = this.store.get('apiConfig');
        apiConfig.headers["Authorization"] = this.idToken;

        return this.http.post(apiConfig.threatsURL, json_token, {headers: apiConfig.headers})
            .map(res => res.json())
            .catch(ThreatService.handleError);
    }

    getThreatLevel(idToken: string, customer: string): Observable<any> {

        // XXX: Bad token - that's bad! Elevate risk???
        if (!idToken) {
            console.log('Bad ID Token');
            return Observable.create(function (observer) {
                observer.next([{'risk': 2}]);
                observer.complete();
            });
        }

        const json_token = {};

        const apiConfig = this.store.get('apiConfig');
        apiConfig.headers["Authorization"] = idToken;

        // TODO: Need to move this over to AuthHttp. Currently it is failing because of JWT token I think!!!
        return this.http.post(apiConfig.threatLevelURL, json_token, {headers: apiConfig.headers})
            .map(ThreatService.extractData)
            .catch(ThreatService.handleError);
    }
}



// WEBPACK FOOTER //
// /app/src/app/shared/threat/threat.service.ts